import React from 'react';
import { ConnectedPageListItem } from './partials/ConnectedPageListItem/ConnectedPageListItem';
import { useConnectedPagesExpandHandler } from '../useConnectedPagesExpandHandler/useConnectedPagesExpandHandler';
import { IConnectedPage } from '../../../../types/api/connectedPages/IConnectedPage';
import { isNullOrUndefined } from '../../../../lib/typeGuards';

type ConnectedPagesTreeProps = {
  connectedPages?: IConnectedPage[];
  initialVisibleDepth: number;
};

export function ConnectedPagesTree({ connectedPages = [], initialVisibleDepth }: ConnectedPagesTreeProps) {
  const { onExpandedButtonClick, isActive } = useConnectedPagesExpandHandler(
    'tree',
    connectedPages,
    initialVisibleDepth,
  );

  if (isNullOrUndefined(connectedPages) || connectedPages.length === 0) {
    return null;
  }

  return (
    <ul className="connected-pages-tree">
      {connectedPages.map(page => (
        <ConnectedPageListItem
          key={`pageLink-${page.pageLink.url}`}
          page={page}
          isActive={isActive}
          onClick={onExpandedButtonClick}
        />
      ))}
    </ul>
  );
}
